import { LoadStatus } from '../load-status';

/**
 * Feature key under which the user-master slice is registered in the root store.
 */
export const USER_MASTER_FEATURE_KEY = 'userMaster';

/**
 * The selected sales-org/plant user, in its plain serializable shape ({@link UserMasterState},
 * never the `UserModel` class). The candidate list resolved during init is intentionally
 * not stored here — it is transient working data owned by the init effect. `status` tracks
 * whether a user has been resolved (see {@link LoadStatus}).
 */
export type UserMasterCollectionState = Readonly<{
    selectedUser?: UserMasterState;
    status: LoadStatus;
}>;

export const initialUserMasterCollectionState: UserMasterCollectionState = {
    selectedUser: undefined,
    status: LoadStatus.Idle,
};

export type UserMasterState = Readonly<{
    frontId: string;
    country: string;
    salesOrg: string;
    plant: string;
    description: string;
    emailId: string;
    appId: string;
    userRole: string;
    personnelArea: string;
    personnelSubArea: string;
}>;
